import React, { useState, useEffect, useRef } from 'react'
import AccessibleFormLabel from './AccessibleFormLabel'
import { Box, Input, FormControl, Button, Link } from '@mui/joy'
import ContactUsLink from './ContactUsLink'
import LegalAgreement from './LegalAgreement'
import { useData } from './DataProvider'
import { SpinnerWhite } from '../../shared/Spinner'
import useTranslation from '../../shared/TranslationProvider'

export default function InviteCodeEntry() {
  const { setFormState, getInvitation, isLoading, setIsLoading, legalNotice } =
    useData()

  const [invitationCode, setInvitationCode] = useState('')
  const headingRef = useRef(null)

  // CTS-9276 (YNS-010): focus page heading on entry instead of autoFocus on the input (focus order).
  useEffect(() => {
    if (headingRef.current) {
      headingRef.current.focus()
    }
  }, [])

  const handleInviteCode = () => {
    setIsLoading(true)
    getInvitation(invitationCode, 'InviteCodeEntry')
  }

  const { t } = useTranslation()

  return (
    <Box>
      <Box>
        {/* CTS-9276 (YNS-010): programmatic focus target; tabIndex -1 excludes from tab order */}
        <h1
          ref={headingRef}
          tabIndex={-1}
          className="m-8 outline-none focus:outline-none"
        >
          {t('InviteCodeEntry.title')}
        </h1>
      </Box>
      <Box className="control-container">
        <FormControl required>
          <AccessibleFormLabel>
            {t('InviteCodeEntry.invitation_code')}
          </AccessibleFormLabel>
          <Input
            name="invitation_code"
            size="lg"
            value={invitationCode}
            onChange={(e) => setInvitationCode(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleInviteCode()
            }}
            slotProps={{
              input: { 'data-testid': 'a11y-op-login--invitation-code' },
            }}
          />
        </FormControl>
      </Box>
      <Box className="button-container">
        <Button
          className="submit-button btn !rounded-full"
          size="lg"
          fullWidth
          onClick={handleInviteCode}
          disabled={isLoading}
        >
          {t('InviteCodeEntry.validate_code')}
          <SpinnerWhite show={isLoading} className="pl-4" />
        </Button>
      </Box>
      <LegalAgreement
        actionText={t('InviteCodeEntry.validate_code')}
        htmlText={legalNotice}
      />
      <ContactUsLink />
      <Box
        className="subtext-bottom-container link-container"
        sx={{
          '--linkMargin': '0',
        }}
      >
        <Link
          component="button"
          type="button"
          underline="always"
          onClick={() => setFormState('LoginForm')}
        >
          {t('InviteCodeEntry.log_in_existing_account')}
        </Link>
      </Box>
    </Box>
  )
}
